import { TFunction } from "i18next";
import * as yup from "yup";

export default function linkEstimationSchema(t: TFunction) {
  return yup.object().shape({
    estimateId: yup.string().required(),
  });
}
